export function archiveImage() {
  const mp = ['-', ''];
  const img = document.querySelectorAll('.js-archive-image-container');

  const closest = (el, targetClass) => {
    for (let item = el; item; item = item.parentElement) {
      if (item.classList.contains(targetClass)) {
        return item
      }
    }
  }

  const getRandNum = (num) => {
    let _mp = mp[Math.floor(Math.random() * mp.length)];
    let rand = Math.random() * num;
    return _mp+rand;
  }

  const getRandNumPlus = (num) => {
    let rand = Math.random() * num;
    return rand;
  }

  const ww = window.document.documentElement.clientWidth;
  for (let i = 0; i < img.length; i++) {
    const el = img[i];
    const image = el.querySelector('.js-archive-image');
    const grp = getRandNumPlus(2000);
    if (ww >= 768) {
      el.style.transform = `translate(${getRandNum(150)}%,${getRandNum(50)}%)`;
    } else {
      el.style.transform = `translate(${getRandNum(100)}%,${getRandNum(50)}%)`;
    }
    image.style.transition = `opacity 1000ms cubic-bezier(0.19, 1, 0.22, 1) ${grp}ms, transform 2000ms cubic-bezier(0.19, 1, 0.22, 1) ${grp}ms, visibility 0ms linear 0ms`;
    el.querySelector('.js-archive-image').classList.add('is-active');
  }
}